/**
 * Base Component class for standardized component lifecycle management.
 */
export abstract class Component {
  protected element: HTMLElement | null = null;

  constructor(selector?: string) {
    if (selector) {
      this.element = document.querySelector(selector);
    }
  }

  /**
   * Initialize the component.
   * Should be called after instantiation.
   */
  public init(): void {
    if (this.element || !this.requiresElement()) {
      this.mount();
    }
  }

  /**
   * Override this method to perform setup logic (event listeners, etc.)
   */
  protected abstract mount(): void;

  /**
   * Override this to return true if the component needs a DOM element to function.
   * Default is false (some components might be global like a Router).
   */
  protected requiresElement(): boolean {
    return false;
  }

  /**
   * Clean up event listeners etc.
   */
  public destroy(): void {
    // Optional cleanup
  }
}
